import {
    getEntitiesByStrategy,
    LOAD_STRATEGIES,
    REFERENCE_CORE_ENTITIES,
    REFERENCE_ENTITIES,
    REFERENCE_PAGE_DEPENDENCIES,
} from '@/config/reference.config.js';
import { tenantSnapshotHasAnyPagePermission } from '@/lib/tenant-role-permissions.js';

/**
 * Computes dependency-aware bulk entities:
 * - core entities always
 * - entities required by pages user can view
 * @param {ReturnType<import('@/lib/tenant-role-permissions.js').getTenantRolePermissionSnapshot>} snapshot
 */
export function getHydratableReferenceEntities(snapshot) {
    const known = new Set(REFERENCE_ENTITIES);
    const bulk = new Set(getEntitiesByStrategy(LOAD_STRATEGIES.BULK));
    const selected = new Set();

    REFERENCE_CORE_ENTITIES.forEach((entity) => {
        if (known.has(entity) && bulk.has(entity)) selected.add(entity);
    });

    Object.entries(REFERENCE_PAGE_DEPENDENCIES).forEach(([pageKey, entities]) => {
        if (!tenantSnapshotHasAnyPagePermission(snapshot, pageKey)) return;
        entities.forEach((entity) => {
            if (known.has(entity) && bulk.has(entity)) selected.add(entity);
        });
    });

    return [...selected];
}

// Backward-compatible alias
export const filterBulkEntitiesForSnapshot = getHydratableReferenceEntities;
